<template>
    <div class="xiangmjiangli">
        <div class="banner"></div>
        <div class="content">
            <div class="top">
                <p class="iconfont icon-24gl-clockCircle pp1"> {{time}}</p>
                <p class="title">
                    <span class="span1">JAVA开发工程师</span>
                    <span class="span2">7000 — 9000 元</span>
                </p>
                <p class="info">
                    <span class="span3">所属部门：技术研发部</span>
                    <span class="span4">江苏省&nbsp;&nbsp;|&nbsp;&nbsp;1-3年&nbsp;&nbsp;|&nbsp;&nbsp;本科&nbsp;&nbsp;|&nbsp;&nbsp;全职&nbsp;&nbsp;|&nbsp;&nbsp;3人&nbsp;&nbsp;</span>
                </p>
            </div>  
            <div class="neirong">
                <p class="p1">职位描述:</p>
                <p class="p2"></p>
                <p class="p3">岗位职责:</p>
                <p class="p4">1、按照产品设计需求进行技术需求分析和软件设计；</p>
                <p class="p4">2、进行软件详细设计和编码实现，确保安全、质量和性能；</p>
                <p class="p4">3、独立完成复杂功能需求理解、设计、开发工作；</p>
                <p class="p4">4、分析并解决开发过程中的问题，拥有较强的逻辑思维能力和学习钻研能力；</p>
                <p class="p4">5、负责系统迭代升级及维护工作；</p>
                <p class="p4">6.提前预估并防范项目问题，对项目执行过程中出现的偏差进行及时纠正。</p>
                <p class="p3 p33">岗位职要求:</p>
                <p class="p4">1、专科以上学历，计算机软件相关专业，2年以上相关工作经验；</p>
                <p class="p4">2、精通Java及面向对象设计开发，扎实的编程基础；</p>
                <p class="p4">3、熟练使用 SpringBoot、SpringCloud、MyBatis等开发框架；</p>
                <p class="p4">4、掌握MySQL、SQL Server、Oracle至少其中一种数据库系统；</p>
                <p class="p4">5、熟练使用Git、Maven、SVN等相关的代码管理工具；</p>
                <p class="p4">6、良好的学习能力、沟通能力、表达能力和分析解决问题能力，工作认真负责，能够承担工作压力；</p>
                <p class="p4">7、拥有强烈的进取心和对工作高度的责任感及良好的团队合作精神。</p>

                <p class="p3 p33">福利待遇:</p>
                <p class="p4">1、公司提供带薪培训；</p>
                <p class="p4">2、丰富的员工活动（各类员工活动、部门聚会、月会、员工生日会、旅游等）；</p>
                <p class="p4">3、薪资：7000—9000；</p>
                <p class="p4"><span class="teshu">其他福利&nbsp;：</span> 朝九晚六，双休，五险一金，法定节假日；带薪年假+生日福利+节假日福利。</p>

                <p class="p4 ps"><span class="teshu">联系电话&nbsp;:</span>&nbsp; 18952039164</p>
                <p class="p4"><span class="teshu">简历邮箱&nbsp;:</span>&nbsp; 624054484@qq.com</p>
                <p class="p4"><span class="teshu">地址&nbsp;: </span>&nbsp; 南京市建邺区国家广告产业园5栋706室</p>
            </div>  
        </div>
    </div>
</template>
        
<script>
export default {
    data () {
        return {
            time:""
        }
    },
   mounted () {
        var now = new Date();  
        var year = now.getFullYear(); //得到年份
        var month = now.getMonth();//得到月份
        var date = now.getDate();//得到日期
        month = month + 1;
        if (month < 10) month = "0" + month;
        if (date < 10) date = "0" + date;
        this.time = year + "-" + month + "-" + date;    //（格式化"yyyy-MM-dd"）   
   }
}
</script>
<style lang='less' scoped>
.xiangmjiangli{
    width: 100%;
    text-align: left;
    .banner{
        width:100% ;
        height: 264px;
        background-image: url("http://img601.yun300.cn/repository/image/10d45510-d4b3-42db-964d-4a1718d44ced.jpg?tenantId=214689&viewType=1&k=1651226704000");
        background-size: 100%;
        background-repeat: no-repeat;
    }  
    .content{
        width: 66%;
        margin: 50px auto 20px;
        .top{
            width: 100%;
            height: 165px;
            box-sizing: border-box;
            padding: 10px 40px 30px;
            background-color: #fbfcfd;
            .pp1{
                color: #666;
            }
            .title{
                height: 70px;
                color: #000;
                .span1{
                    font-size: 38px;
                    line-height: 70px;
                }
                .span2{
                    color: #ff5959;
                    font-weight: bold;
                    font-size: 30px;
                    line-height: 70px;
                    float: right;
                }
            }
            .info{
                margin-top: 10px;
                .span3{
                    font-size: 14px;
                    color: #999;
                    height: 20px;
                    line-height: 20px;
                }
                .span4{
                    font-size: 14px;
                    color: #999;
                    float: right;
                    margin-right: 40px;
                }
            }
        }
        .neirong{
            width: 100%;
            padding: 25px;
            box-sizing: border-box;
            .p1{
                font-size: 16px;
                color: #333;
                line-height: 40px;
            }
            .p2{
                width: 21px;
                height: 2px;
                background-color: #04abf4;
            }
            .p3{
                height: 36px;
                line-height: 36px;
                font-size: 15px;
                color: #333;
                font-weight: bold;
                margin-top: 18px;
            }
            .p4{
                height: 36px;
                line-height: 36px;
                font-size: 14px;
                color: #333;
            }
            .p33{
                margin-top: 30px;
            }
            .teshu{
                line-height: 36px;
                font-size: 15px;
                color: #333;
                font-weight: bold;
            }
            .ps{
                margin-top: 36px;
            }
        }
    }
}
</style>